/*** 
 * 描述：点击头像 修改密码模态框
 */ 
import { Component, OnInit, ViewChild, EventEmitter, Output, Input} from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { OninitService } from "src/app/librarys/serves/oninit.service";
import { Router } from "@angular/router";
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { Md5 } from "ts-md5";
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
@Component({
  selector: 'app-sw-change-password', 
  templateUrl: './sw-change-password.component.html',
  styleUrls: ['./sw-change-password.component.css']
})
export class SwChangePasswordComponent implements OnInit {

  @ViewChild('changePasswordModal') changePasswordModal: SwModalframeComponent; //模态框组件 
  @Input() param: any;
  @Output() callback = new EventEmitter(); //抛出事件
  invalid: boolean = false; //判断表单保存是否符合条件
  newPattern:boolean = false;
  passwordModel: any = {}; //密码对象
  @ViewChild("tirm") tirm: SwMassageConfirmComponent; //弹出层组件
  ifCancel: boolean = false;
  headerLogo: string = '提示';
  constructor(
    private _http:SwHttpClientService, //请求服务对象
    private box:SwMassageBoxService, //提示框对象
    private init: OninitService, //初始化服务方法
    private router: Router, //路由服务
    private jwt: SwJwtService
  ) {
  
   }

  ngOnInit() {
  }
 
  clickPassword($event) {
    let newPassword = $event.target.value
    let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W|_]).{8,}$/
    this.newPattern = !reg.test(newPassword);
  }

  //提交 修改密码
  onSubmit({ value, valid }, event: Event) {
    //包含大小写字母、数字和特殊字符，至少8位
   // let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[1-9])(?=.*[\W]).{8,}$/
    if (valid && !this.newPattern && this.passwordModel['newPassword'] == this.passwordModel['confirmPassword']) {
      //校验密码长度
      // if(!reg.test(this.passwordModel.newPassword)){
      //   this.box.danger("新密码至少8个长度、含大小写、数字、特殊字符");
      // }else {
        //请求修改密码
        let newPwd = Md5.hashStr(value.NewPassword);
        let oldPwd = Md5.hashStr(value.OldPassword);
        // this._http.Post(environment.seekerWebAPI+"sw/changePwd?oldPassword="+value.OldPassword+"&newPassword="+value.NewPassword,{} ).subscribe(
          this._http.Post(environment.seekerWebAPI+"sw/changePwd?oldPassword="+oldPwd+"&newPassword="+newPwd,{} ).subscribe(
          data => {
            //请求成功
            if(data["code"]==200){
              //提示 
              //this.box.success("密码修改成功");
              //关闭模态框
              this.changePasswordModal.toggle()
              // this._http
              // .Post(`${environment.seekerWebAPI}sw/logout`, null)
              // .subscribe(r => {
              //     this.tirm.openCLick("当前用户已成功修改密码，请重新登录系统", (data) => { //确认弹出框
              //       if (data) {
              //           //注销系统
              //           this.init.GC(); // 清除缓存，工作台和路由复用
              //           this.router.navigate(["login"]); //跳转到登入页面
              //           this.box.success("重新登录"); //提示
              //       }
              //     })
              // });

              this.tirm.openCLick("当前用户已成功修改密码，请重新登录系统", (data) => { //确认弹出框
                if (data) {
                    //注销系统
                    this.exit();
                }
                  //销毁组件
                  this.callback.emit()
              })
              
            }else if(data["msg"]){
              //请求失败 提示错误
              this.box.waring(data["msg"]);
              
            }
          }
        )
     // }
    }else {
      this.invalid = true;
      this.box.waringError('请输入完整且正确的信息')
    }
  }

  //修改密码成功后，退出系统
  exit() {
    //请求退出系统
    const CALogin = this.jwt.getToken('CALogin');
    if (CALogin) {
      this.init.GC(); // 清除缓存，工作台和路由复用
      this.router.navigate(["login"]); //跳转到登入页面
    } else {
      this._http
      .Post(`${environment.seekerWebAPI}sw/logout`, null)
      .subscribe(r => {
        this.init.GC(); // 清除缓存，工作台和路由复用
        this.router.navigate(["login"]); //跳转到登入页面
        //this.box.success("重新登录"); //提示
      });
    }
  }

  //点击取消
  cancel(){
    //关闭模态框
    this.changePasswordModal.toggle()
    //销毁组件
    this.callback.emit()

  }
}
